import styled from "@emotion/styled"
import { memo } from "react"
import ButtonRegular from "@/components/composite/ButtonRegular/main"
import { ImageComponent } from "@/components/base/Image"
import kycController from "@/features_signal/kyc/kycController"
import { computed } from "@preact/signals"
interface AccountItemProps {
    icon: string
    label: string
    text?: string
    onClick?: () => void
    showArrow?: boolean
    needBorder?: boolean
    rightButton?: {
        text: string
        onClick: () => void
    }
    status?: Kyc.Status
}

const ItemWrapper = styled.div<{ needBorder?: boolean }>`
    display: flex;
    align-items: center;
    border-bottom: ${(props) => (props.needBorder === false ? "none" : "1px solid #0E0F1B1A")};
    height: 48rem;
    line-height: 24rem;
    font-weight: 500;
    cursor: pointer;
`

const IconWrapper = styled.img`
    width: 24rem;
    height: 24rem;
    margin-right: 12rem;
    display: flex;
    align-items: center;
`

const Label = styled.span`
    font-size: 16rem;
    color: #131416;
    flex: 1;
`

const RightDisplay = styled.span<{ status?: Kyc.Status }>`
    font-size: 16rem;
    margin-right: 4rem;
    color: ${(props) => {
        switch (props.status) {
            case "unset":
                return "#69728C"
            case "basic_account":
                return "#69728C"
            case "under_review":
                return "#FF8800"
            case "rejected":
                return "#F51450"
            case "basic_kyc":
                return "#0CC048"
            case "fully_kyc":
                return "#0CC048"
            case "frozen":
                return "#F51450"
            case "block":
                return "#F51450"
            case "test_account":
                return "#0CC048"
            default:
                return "#69728C"
        }
    }};
`

const Arrow = styled(ImageComponent("pages/AccountPage/item/arrow_right.webp"))`
    width: 24rem;
    height: 24rem;

    > img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`

const RightButton = styled(ButtonRegular)`
    font-family: "Gilroy";
    height: 24rem;
    color: white;
    border-radius: 4rem;
    font-size: 12rem;
    border: none !important;
    background: linear-gradient(180deg, #3385ff 0%, #0a6cff 100%) !important;
    padding: 4rem 8rem;
    line-height: 16rem;
    box-shadow: none !important;
`

export const AccountItem = memo(
    ({
        icon,
        label,
        text,
        onClick,
        showArrow = true,
        needBorder = true,
        rightButton,
        status,
    }: AccountItemProps) => {
        const shouldShowArrow = computed(() => {
            if (!onClick) return false
            if (label === "KYC" && status !== "rejected") return false
            return showArrow
        })
        return (
            <ItemWrapper
                needBorder={needBorder}
                onClick={onClick}
            >
                <IconWrapper src={icon}></IconWrapper>
                <Label>{label}</Label>
                {rightButton && status !== "rejected" ? (
                    <RightButton onClick={rightButton.onClick}>{rightButton.text}</RightButton>
                ) : (
                    <RightDisplay
                        status={status as Kyc.Status}
                        onClick={onClick && (() => onClick())}
                    >
                        {text}
                    </RightDisplay>
                )}
                {shouldShowArrow.value && <Arrow />}
            </ItemWrapper>
        )
    },
    (prevProps, nextProps) => {
        return (
            prevProps.text === nextProps.text &&
            prevProps.needBorder === nextProps.needBorder &&
            prevProps.showArrow === nextProps.showArrow &&
            prevProps.status === nextProps.status &&
            prevProps.onClick === nextProps.onClick
        )
    },
)
